import { ResourceCrudPage } from '@/components/crud/ResourceCrudPage'

/** Verify, ownership, features, domain and credit actions live on the record sheet
 * (declared in backend/admin_api/resources/business.py). */
export function BusinessesPage() {
  return (
    <ResourceCrudPage
      resource="directory__business"
      channelGroup="admin.directory"
      title="Businesses"
      description="Black-owned businesses listed in the directory. Click a business to see everything about it and act on it."
    />
  )
}
